import React, {useEffect, useState} from 'react';
import Num2persian from "num2persian";
import {PharmaciesSelectedItem, PharmaciesSelectItem} from "./edit-request.styles";
import {Link, useNavigate, useParams} from "react-router-dom";
import moment from 'moment-jalaali';
import {Modal} from 'react-responsive-modal';
import {fetchData} from "../../../helpers/general-function";
import {Jumbotron} from "../../../core-ui/jumbotron/jumbotron";
import {Alert, CustomSelectSearch} from "../../../core-ui";
import RequestShiftCard from "../../../components/request-shift-card/request-shift-card";
import CustomTextArea from "../../../core-ui/input/custom-text-area";
import {ShiftModalContainer} from "../../Requests/requests.styles";

const shiftData = [
    {start_date: moment(), start_time: '', end_date: moment(), end_time: '', earning: '', settlement_date: moment()},
];

const data = {
    state: '',
    city: '',
    pharmacy_id: '',
    shift_times: shiftData,
    description: ''
};

const EditRequest = () => {

    const {request_id} = useParams();
    const navigate = useNavigate();

    const [requestFormData, setRequestFormData] = useState(data);
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [pharmacies, setPharmacies] = useState([]);
    const [deleteShiftModal, setDeleteShiftModal] = useState(null);

    useEffect(() => {
        (async () => {
            // const requestPrevData = await fetchData(`panel/shift-times/edit/${request_id}`, 'post', {}, true);
            // console.log(requestPrevData)
            const data = await fetchData('assets/provinces', 'get');

            if (data) {
                const finalProvinces = data.provinces.map(item => ({
                    name: item.name, value: item.id
                }));
                setProvinces(finalProvinces);
            }

        })();
    }, [])

    const addShift = () => {
        let newItem = [...requestFormData.shift_times, ...shiftData];
        setRequestFormData(prevState => ({
            ...prevState, shift_times: newItem
        }));

        //scroll to
        // console.log('scroll');
    }

    const deleteShift = () => {
        let currentItems = [...requestFormData.shift_times];
        let newItems = currentItems.filter((_, index) => index !== deleteShiftModal);

        setRequestFormData(prevState => ({
            ...prevState, shift_times: newItems
        }));
        setDeleteShiftModal(null);
        Notification.warning('شیفت مورد نظر حذف شد');
    }

    const changeHandler = ({target: {name, value}}) => {
        setRequestFormData(prevState => ({...prevState, [name]: value}));
    }

    const onProvinceChange = async (value) => {
        if (value) {
            const data = await fetchData(`assets/provinces/${value}/cities`, 'get');

            if (data) {
                const finalCities = data.cities.map(item => ({
                    name: item.name, value: item.id
                }));

                setRequestFormData(prevState => ({...prevState, state: value}));
                setCities(finalCities)
            }
        }
    }

    const onCityChange = async (value) => {
        if (value) {
            const data = await fetchData(`assets/cities/${value}/pharmacies`, 'get');

            if (data) {
                const finalPharmacies = data.pharmacies.map(item => ({
                    name: item.name, value: item.id, address: item.address
                }));

                setRequestFormData(prevState => ({...prevState, city: value}));
                setPharmacies(finalPharmacies)
            }
        }
    }

    const changeShiftDataHandler = (name, value, id, isTime = false) => {
        // const currentShiftTimes = [...requestFormData.shift_times];
        //
        // const editedShiftTimes = currentShiftTimes.map((item, index) => {
        //     if (index === id) {
        //         return {
        //             ...item,
        //             [name]: isTime ? `${value.hour}:${value.minute}` : value
        //         }
        //     } else {
        //         return item;
        //     }
        // });

        // console.log(currentShiftTimes, editedShiftTimes)

        setRequestFormData(prevState => {
            const shift_times = prevState.shift_times.map((item, index) => {
                if (index === id) {
                    return {
                        ...item,
                        [name]: isTime ? `${value.hour}:${value.minute}` : value
                    }
                } else {
                    return item;
                }
            });

            return {
                ...prevState,
                shift_times
            }
        })

    }

    const sendRequestForm = async () => {
        const currentShiftTimes = [...requestFormData.shift_times];

        const finalShiftTimes = currentShiftTimes.map(item => ({
            from: `${moment(item.start_date).format('YYYY-MM-DD')} ${item.start_time}:00`,
            to: `${moment(item.end_date).format('YYYY-MM-DD')} ${item.end_time}:00`,
            settlement_date: moment(item.settlement_date).format('YYYY-MM-DD'),
            earning: item.earning
        }));

        const data = await fetchData('shifts/create', 'post',
            {...requestFormData, shift_times: finalShiftTimes}, true, {isHeaderJson: true}
        )

        if (data) {
            Notification.success('شیفت مورد نظر با موفقیت ایجاد شد');
            navigate('/panel/my-requests');
        }

    }

    return (
        <>
            <div className='container mt-4'>
                <Jumbotron>
                    <div className='d-flex align-items-center justify-content-between'>
                        <h3 className='success-color fw-normal'>درخواست از داروسازان برای پذیرفتن شیفت</h3>
                        <Link to='/panel/my-requests'><h3 className='danger-color fw-normal cursor-pointer'>حذف درخواست</h3></Link>
                    </div>
                    <div className='row justify-content-center mt-c-4'>
                        <div className="col-12 col-md-6 col-lg-4">
                            <CustomSelectSearch
                                icon={<i className='icon-buildings-2'/>}
                                label='استان'
                                onChange={onProvinceChange}
                                value={requestFormData.state}
                                name='state'
                                emptyMessage='استان مورد نظر وجود ندارد'
                                options={provinces}
                                placeholder="انتخاب کنید"/>

                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mt-5 mt-md-0">
                            <CustomSelectSearch
                                icon={<i className='icon-building'/>}
                                label='شهر'
                                disabled={!!!requestFormData.state}
                                onChange={onCityChange}
                                value={requestFormData.city}
                                name='city'
                                emptyMessage='استان مورد نظر وجود ندارد'
                                options={cities}
                                placeholder="انتخاب کنید"/>
                        </div>
                        <div className="col-12 col-md-6 col-lg-8 mt-5">
                            <CustomSelectSearch
                                renderOption={(optionsProps, optionData, optionSnapshot) =>
                                    <PharmaciesSelectItem {...optionsProps}
                                                          className={optionSnapshot.selected ? 'is-selected' : ''}>
                                        {optionData.name}
                                        <span>( {optionData.address} )</span>
                                    </PharmaciesSelectItem>
                                }
                                // renderValue={(valueProps, selectedValue) =>
                                //     <input {...valueProps}
                                //            className='select-search__input'
                                //            value={selectedValue.option ? `${selectedValue.option?.name} ( ${selectedValue.option?.address} )` : 'داروخانه سیب'}/>}
                                renderValue={(valueProps, selectedValue) =>
                                    <PharmaciesSelectedItem {...valueProps} className='select-search__input'>
                                        {
                                            selectedValue.option ?
                                                <>
                                                    {selectedValue.option?.name}
                                                    <span>( {selectedValue.option?.address} )</span>
                                                </>
                                                :
                                                'داروخانه سیب'
                                        }
                                    </PharmaciesSelectedItem>
                                }
                                icon={<i className='icon-hospital'/>}
                                disabled={!!!requestFormData.city}
                                label='داروخانه'
                                onChange={(value) => changeHandler({target: {name: 'pharmacy_id', value}})}
                                value={requestFormData.pharmacy_id}
                                name='pharmacy_id'
                                emptyMessage='داروخانه مورد نظر وجود ندارد'
                                options={pharmacies}
                                placeholder="داروخانه سیب"/>
                        </div>
                    </div>
                    <div>
                        {
                            requestFormData.shift_times.map((item, index) => (
                                <RequestShiftCard key={index} shiftTitle={Num2persian(index + 1)}
                                                  onDeleteShift={() => setDeleteShiftModal(index)}
                                                  changeHandler={changeShiftDataHandler}
                                                  shiftData={item} id={index}/>
                            ))
                        }
                        {
                            requestFormData.shift_times.length < 4 &&
                            <button className='btn-text success-color mt-3' onClick={addShift}>
                                <i className='icon-location ms-2'/>
                                افزودن شیفت دیگر
                            </button>
                        }

                    </div>
                    <CustomTextArea classNames='col-12 col-md-8 mx-auto mt-c-5' label='توضیحات'
                                    subLabel='(اختیاری - شرایط داروخانه، نحوه پرداخت، هماهنگی و غیره)'
                                    onChange={changeHandler}
                                    name='description'
                                    value={requestFormData.description}
                                    icon={<i className='icon-document-text'/>}
                                    placeholder='توضیحات'>

                    </CustomTextArea>
                    <div className='mt-c-5 text-center'>
                        <button className='c-btn c-btn-success px-4 py-2' onClick={sendRequestForm}>ارسال درخواست
                        </button>
                    </div>
                </Jumbotron>
            </div>

            <Modal open={!!deleteShiftModal} onClose={() => setDeleteShiftModal(null)}
                   classNames={{modal: 'c-modal-container'}}
                   showCloseIcon={false} center>
                <ShiftModalContainer className='text-center'>
                        <Alert alertClassName='icon-close-circle'/>
                        <p className='dark-danger-color fs-c-3 mt-5'>از لغو این شیفت مطمئن هستید؟</p>
                        <div className='d-flex align-items-center mt-c-5 justify-content-center ms-5'>
                            <button className='btn-text dark-gray me-5' onClick={() => setDeleteShiftModal(null)}>بازگشت به صفحه قبلی</button>
                            <button className='c-btn simple-btn-danger px-3' onClick={deleteShift}>لغو درخواست ارسال شده</button>
                        </div>
                </ShiftModalContainer>
            </Modal>
        </>
    );
};

export default EditRequest;
